import React from 'react';
import Thumbnail from '../Media/Thumbnail/Thumbnail';
import * as constants from '../../constants';

const MarkerPopup = ({
  id,
  name,
  description,
  panoId,
  switchView,
  changeStop,
  order,
  tourId,
  mainMediaType,
}) => {
  const handlePanoClick = () => {
    if (typeof switchView === 'function' && typeof changeStop === 'function') {
      switchView({ miniMapView: 'map', id: tourId, name });
      changeStop({ stopNum: order, stopName: name, origin: 'popup pano' });
    }
  };

  return (
    <div id={id} key={id}>
      <h3>{name}</h3>
      {panoId && (
        <Thumbnail
          mediaId={panoId}
          mediaType={mainMediaType || constants.PANOS} // default to panos for old stop images that dont have the mainMediaType key/value
          thumbClass="popup-thumbnail"
          height={200}
          alt=""
          handleClick={handlePanoClick}
        />
      )}
    </div>
  );
};

export default MarkerPopup;
